import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    height: auto;
    min-height: 63px;
    padding: 10px 15px;

    font-size: 18px;
    line-height: 26px;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    white-space: pre-wrap;

    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    background: ${SEMANTIC_COLORS.DEFAULT_CHIPS_BACKGROUND};
    border: ${(props) => props.isSelected ? `3px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}` : '3px solid transparent'};

    border-radius: 10px;
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};

    &::after {
      position: absolute;
      top: -1px;
      right: -1px;
      content: '';
      border-top: ${(props) => props.isSelected ? `10px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}` : 'none'};

      border-right: ${(props) => props.isSelected ? `10px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}` : 'none'};
      border-bottom: 10px solid transparent;
      border-left: 10px solid transparent;
      border-radius: 0 4px 0 0;
    }
  `,
};
